import uniq from 'uniqid';

export const generateUniqId = (namespace?: string) => uniq(namespace ?? '');
